import React from 'react';
import { Form } from 'react-bootstrap';
import { gameStateManager } from '../../App';
import SliderOption from '../Utils/SliderOption';
import '../../css/bugReportRow.css';

export default class PlayedGameRow extends React.Component
{
  state = {
    skipToTileIndex: 0,
    skipToFeatureResolveIndex: 0,
    playbackTurnSpeed: 2,
    resolveAILogic: true
  };

  onDebugPlayback = event =>
  {
    event.preventDefault();

    // Process the forms input data to get the played game ID
    const formData = new FormData( event.target );
    const formDataObj = Object.fromEntries( formData.entries() );

    const {
      playedGameId
    } = formDataObj;

    const { skipToTileIndex, skipToFeatureResolveIndex, playbackTurnSpeed, resolveAILogic } = this.state;

    console.log( "skipToTileIndex : " + skipToTileIndex, "skipToFeatureResolveIndex : ", skipToFeatureResolveIndex, "playbackTurnSpeed", playbackTurnSpeed );

    // Create the playback URL with parameters for played games
    const baseUrl = window.location.origin;
    const playbackUrl = `${baseUrl}/playback?playedRoomId=${playedGameId}&skipToTile=${skipToTileIndex}&skipToFeature=${skipToFeatureResolveIndex}&speed=${playbackTurnSpeed}&resolveAILogic=${resolveAILogic ? 1 : 0}`;

    // Open the debug playback in a new tab
    window.open( playbackUrl, '_blank', 'noopener,noreferrer' );
  };

  onServerErrorReceived = errorData =>
  {
    console.log( "onServerErrorReceived - ", errorData );
  }

  render()
  {
    let data = this.props.playedGameData;

    return (
      <div className="bug-report-row">
        <Form onSubmit={ this.onDebugPlayback }>

          <div className="bug-report-header">
            <div className="bug-report-info room-id">
              <span className="label">Room:</span> { data.roomId }
            </div>

            <div className="bug-report-info players-count">
              <span className="label">Players:</span> { data.numPlayers }
            </div>

            <div className="bug-report-info moves-count">
              <span className="label">Moves:</span> { data.numTilePlacements }
            </div>

            <div className="bug-report-info date-reported">
              <span className="label">Played:</span> { data.dateReported }
            </div>
          </div>

          <input
            type="hidden"
            value={ data.playedGameId }
            name="playedGameId"
          />

          <div className="bug-report-controls">
            <div className="control-group">
              <SliderOption
                title="Skip To Tile:"
                min={ 0 }
                max={ data.numTilePlacements }
                value={ 0 }
                onValueChange={ ( newValue ) => { this.setState( { 'skipToTileIndex': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <SliderOption
                title="Skip To End Game Feature Resolve:"
                min={ 0 }
                max={ 50 }
                value={ 0 }
                onValueChange={ ( newValue ) => { this.setState( { 'skipToFeatureResolveIndex': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <SliderOption
                title="Play Speed (Seconds):"
                min={ 0 }
                max={ 10 }
                value={ this.state.playbackTurnSpeed }
                onValueChange={ ( newValue ) => { this.setState( { 'playbackTurnSpeed': newValue } ); } }
              />
            </div>

            <div className="control-group">
              <Form.Check
                type="switch"
                id="resolveAILogic"
                label="Resolve AI Logic"
                checked={ this.state.resolveAILogic }
                onChange={ ( event ) => { this.setState( { 'resolveAILogic': event.target.checked } ); } }
              />
            </div>

            <button type="submit" className="debug-button">
              Debug Playback
            </button>
          </div>
        </Form>
      </div>
    );
  }
}
